import { ReportLayoutSettingsService } from '@app/shared/report/report-layout-settings.service';

export function reportLayoutSettingsInitializer(reportLayoutSettingsService:ReportLayoutSettingsService) {
  return reportLayoutSettingsService.activateAutoSave;
}